/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Clear_CustomizationInputs */

const en_admin_resource_form_clear_customization = /** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const de_admin_resource_form_clear_customization = /** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

const es_admin_resource_form_clear_customization = /** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer`)
};

const fr_admin_resource_form_clear_customization = /** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser`)
};

const nl_admin_resource_form_clear_customization = /** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissen`)
};

/** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */
const it_admin_resource_form_clear_customization = en_admin_resource_form_clear_customization;

/** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */
const pt_br2_admin_resource_form_clear_customization = en_admin_resource_form_clear_customization;

/** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */
const pl_admin_resource_form_clear_customization = en_admin_resource_form_clear_customization;

/** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */
const hu_admin_resource_form_clear_customization = en_admin_resource_form_clear_customization;

/** @type {(inputs: Admin_Resource_Form_Clear_CustomizationInputs) => LocalizedString} */
const ro_admin_resource_form_clear_customization = en_admin_resource_form_clear_customization;

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Admin_Resource_Form_Clear_CustomizationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_clear_customization = /** @type {((inputs?: Admin_Resource_Form_Clear_CustomizationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Clear_CustomizationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_clear_customization(inputs)
	if (locale === "de") return de_admin_resource_form_clear_customization(inputs)
	if (locale === "es") return es_admin_resource_form_clear_customization(inputs)
	if (locale === "fr") return fr_admin_resource_form_clear_customization(inputs)
	if (locale === "nl") return nl_admin_resource_form_clear_customization(inputs)
	if (locale === "it") return it_admin_resource_form_clear_customization(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_clear_customization(inputs)
	if (locale === "pl") return pl_admin_resource_form_clear_customization(inputs)
	if (locale === "hu") return hu_admin_resource_form_clear_customization(inputs)
	return ro_admin_resource_form_clear_customization(inputs)
});
export { admin_resource_form_clear_customization as "admin.resource_form.clear_customization" }